import {
  getMaxDaysBeforeSwitchToRed,
  getMaxStatusDays,
} from "../tools/ConfigurationReader";

export default () => {
  return {
    translation: {
      date: {
        long: "YYYY-MM-DD HH:mm:ss",
        short: "yyyy-MM-dd",
        shortDayJS: "YYYY-MM-DD",
        technicalDate: "yyyy-MM-dd",
        technicalDatetime: "yyyy-MM-dd HH:mm:ss",
        apiFormat: "YYYY-MM-DD_HH-mm-ss",
      },
      ui: {
        rotateLabel: "Rotate",
        history: "History",
        marketProperties: "Properties",
        toReview: "To review",
        toBeReviewedSoon: "To be reviewed soon",
        okay: "Okay",
        logout: "Logout",
        close: "Close",
        save: "Save",
        delete: "Delete",
        changeShelfLife: "Shelf life verified",
        changeShelfLifeMessage: "Did you verify the shelf completely?",
        date: "Date",
        user: "User",
        status: "Status",
        marketComponentName: "Name",
        historyDialogMarketHeading: "History of Market",
        historyDialogMarketComponentHeading: "History of Market Component",
        no: "No",
        yes: "Yes",
        goToHistory: "Go to history",
        placeholderForEmail: "Email",
        placeholderForPassword: "Password",
        login: "Login",
        noMarketAvailable: "No Market",
        categoryLabel: "Category",
        statusLabel: "Status",
        number: "Number",
        criticalDate: "Most critical MDD",
        redRackButton: "Next Validation",
        noRackForValidation: "All racks are already validated!",
        objectSelection: "Object Selection",
        marketSelection: "Market Selection",
        newMarketComponent: "Object",
        newMarketComponentDescription: "Object",
        placeholderForMarketComponentShortDescription: "Short Description",
        marketComponentNumberLabel: "Rack Number",
        shortDescriptionLabel: "Short Description",
        articleTypeLabel: "Article Type",
        switchToYellowAfterXDays: "Switch to Yellow after X Days",
        switchToRedAfterXDays: "Switch to Red after X Days",
        switchToRedAfterDate: "Set most critical MDD?",
        daysBeforeSwitchToRed: "Days before critical MDD",
        switchToRedAfterDatePlaceholder: "Select date",
        noImageFound: "No image found",
        marketNameLabel: "Market Name",
        marketStreetLabel: "Street",
        marketHouseNumberLabel: "House-Number",
        marketZipLabel: "ZIP",
        marketCityLabel: "City",
        marketDistrictLabel: "District",
        marketAreaXLabel: "Height (X)",
        marketAreaYLabel: "Width (Y)",
        marketEnableMarketDrawing: "Enable Market Drawing",
        marketEnableMarketDrawingToggleEnable: "Enable",
        marketEnableMarketDrawingToggleDisable: "Disable",
        upload: "Upload",
        altLogo: "Regalmonitor",
        versionString: "Version:",
        versionDelimiter: "#",
        altBackground: "Background",
        reduceArticleNow: "Is is better to reduce the article now",
        lastValidationDate: "Last validation on",
        tryAgain: "Try again",
        versionChanges:
          "There has been an update to the application, so you will be logged out in the next few seconds",
        adminLogout:
          "The admin forced a logout for the complete system, in a few seconds you will be logged automatically",
        administration: "Administration",
        userManagement: "User Management",
        marketManagement: "Market Management",
        reporting: "Reporting",
        userLogoutButton: "Logout all",
        userLogoutMessage:
          "Are you sure to logout all users which are logged in on the system?",
        page: "Page",
        next: "next",
        previous: "previous",
        selectDate: "Select date",
        userCreate: "Create user",
        userEdit: "Edit user",
        password: "Password",
        repeatPassword: "Repeat password",
        role: "Role",
        noOptionsMessage: "No Optionen",
        userMarketDialogHeader: "Market user allocations",
        select: "Select...",
        userResetPasswordDialogHeader: "Reset user password",
        markets: "Markets",
        reportMarketComponentHistory: "Complete history markets",
        reportMarketComponent_30_60_90_Verification:
          "Market-Component validation state",
        reportMarketComponentWithoutCriticalBBD:
          "Market-Component no critical BBD",
        reportMarketComponentWhereShortDescriptionNotEqualsNumber:
          "Market-Component short description not equals number",
        reportUser: "Employee Highscore",
      },
      table: {
        general: {
          contains: "Contains",
          notContains: "Does not contain",
          equals: "Equals",
          notEqual: "Does not equal",
          startsWith: "Begins with",
          endsWith: "Ends with",
          blank: "Blank",
          notBlank: "Not blank",
          and: "AND",
          or: "OR",
          filter: "Filter...",
          actions: "Actions",
          firstPage: "First Page",
          lastPage: "Last Page",
          prevPage: "Previous Page",
          nextPage: "Next Page",
          page: "Page",
          csvExport: "Export complete report as CSV",
        },
        userManagement: {
          username: "Username",
          firstname: "Firstname",
          lastname: "Lastname",
          languageCode: "Language Code",
          email: "Email",
          deactivated: "Deactivated",
          deactivatedBy: "Deactivated By",
          addUser: "Add User",
          deactivateSelected: "Deactivated Selected",
          activateSelected: "Activated Selected",
          edit: "Edit",
          deactivate: "Deactivate",
          activate: "Activate",
          selectMarket: "Select Markets",
          resetPassword: "Reset Password",
          markets: "Markets",
        },
        reportMarketComponentHistory: {
          market: "Market",
          marketComponentName: "Component Name",
          marketComponentNumber: "Component Number",
          date: "Date",
          username: "Username",
          status: "Status",
          criticalDate: "Critical BBD",
        },
        reportMarketComponent: {
          shortDescription: "Short Description",
          description: "Description",
          articleType: "Article Type",
          type: "Type",
          marketName: "Market-Name",
          number: "Number",
          lastValidation: "Last Validation",
          created: "Created",
        },
        reportUser: {
          username: "Username",
          firstname: "Firstname",
          lastname: "Lastname",
          checkCount: "Count of Checks",
          deactivated: "Deactivated",
          deactivatedBy: "Deactivated By",
        },
      },
      error: {
        baseUrlNotSet: "Base URL is not defined in the environment variables",
        invalidTokenResponse:
          "The authentication process cannot be finished successfully. Please, try it again later",
        invalidUserProfileResponse:
          "The user profile cannot be loaded. Please, try it again later",
        invalidValueForRotate: "The inserted value must be between 0 and 359",
        invalidValueForSwitchToYellowAfterXDays: `The inserted value must be between 1 and ${getMaxStatusDays()}`,
        invalidValueForSwitchToRedAfterXDays: `The inserted value must be between 1 and ${getMaxStatusDays()}`,
        invalidValueForSwitchToRedAfterDate:
          "The inserted value is to far in future",
        invalidValueForDaysBeforeSwitchToRed: `The inserted value must be between 1 and ${getMaxDaysBeforeSwitchToRed()}`,
        failedToFetchImage: "Failed to fetch image",
        webSocketNotConnected:
          "WebSocket not connected; the market component synchronisation is disabled temporarily",
        errorPageHeading: "Something went wrong!",
        errorPageContent:
          "Don't panic!\nIf the problem persists, please contact your system administrator or supervisor.\nThey can help you further!",
        errorInvalidReport: "Invalid report selected",
        unknownError: "Unknown error occurred",
        unknownReportingType: "Unknown reporting type",
      },
      success: {
        marketComponentDeleted: "Market component deleted successfully",
        marketComponentsSaved: "Market components saved successfully",
        webSocketConnected:
          "WebSocket connected; the market component synchronisation is activated",
        userSaved: "User saved successfully",
        csvExportDownloaded: "The CSV export was downloaded",
      },
      apiStatus: {
        GREEN: "Green",
        GREENCYAN: "Green",
        YELLOW: "Yellow",
        RED: "Red",
        WHITE: "Not verified",
        UNKNOWN: "Unknown",
      },
      apiSuccess: {
        MARKET_COMPONENT_STATUS_UPDATED: "Market component status updated",
        MARKET_COMPONENT_DELETED: "Market component deleted successfully",
        NO_EXPIRED_MARKET_COMPONENTS_AVAILABLE_FOR_MARKET_ID:
          "No expired market components available for this market ID",
        FILE_UPLOADED: "File uploaded",
        LOGGING_SUCCESSFUL: "Logging successful",
        AUTO_LOGOUT_SENT:
          "Auto logout sent. In the next view seconds all users of the system will be logged out",
        USER_STATUS_UPDATED: "User status updated successfully",
        PASSWORD_RESET: "Password reset successfully",
      },
      apiError: {
        INVALID_CREDENTIALS: "Invalid credentials",
        INSUFFICIENT_PERMISSIONS: "Insufficient permissions",
        INVALID_ARGUMENT_EXPECTED_SIZE: "Invalid argument expected size",
        INVALID_ARGUMENT_EXPECTED_POSITION:
          "Invalid argument expected position",
        INVALID_ARGUMENT_EXPECTED_MARKET_CONFIGURATION:
          "Invalid argument expected market configuration",
        INVALID_JSON: "Invalid json",
        INVALID_MARKET_ID: "Invalid market id",
        NO_MARKET_COMPONENTS_AVAILABLE_FOR_MARKET_ID:
          "No market components available for this market ID",
        UNSUPPORTED_HTTP_METHOD: "Unsupported HTTP method",
        UNSUPPORTED_URI: "Unsupported URI",
        INVALID_MARKET_COMPONENT_ID: "Invalid market component id",
        INVALID_MARKET_COMPONENT_TYPE_ID: "Invalid market component type id",
        INVALID_MARKET_COMPONENT_ARTICLE_TYPE_ID:
          "Invalid market component article type id",
        TEXT_LENGTH_FOR_SHORT_DESCRIPTION_TOO_LONG:
          "Text length for short description too long",
        INVALID_CHANGE_DATE_SET: "Invalid change date set",
        INVALID_CHANGE_DATE_SET_FOR_USER: "It is better to reduce the article",
        USER_IDENTIFIER_MUST_NOT_BE_EMPTY: "User identifier must not be empty",
        STATUS_YELLOW_DAYS_CANNOT_LARGER_THAN_RED_DAYS:
          "The inserted days for yellow status cannot be larger than red days",
        FILE_NOT_FOUND: "File not found",
        INVALID_MIME_TYPE: "Invalid mime type",
        INVALID_FILE_TARGET: "Invalid file target",
        INVALID_ENTITY_ID_FOR_FILE_TARGET: "Invalid entity id for file target",
        INVALID_FILE_CONTENT: "Invalid file content",
        CANNOT_CREATE_TARGET_FOLDER: "Cannot create target folder",
        FILE_CANNOT_BE_MOVED: "File cannot be moved",
        FILE_CANNOT_BE_REPLACED: "File cannot be replaced",
        ERROR_PAGE_CONTENT:
          "Don't panic! If the problem persists, please contact your system administrator or supervisor. They can help you further!",
        INVALID_JWT: "Invalid JWT",
        INVALID_ROLES: "Invalid roles",
        INVALID_PERMISSIONS: "Invalid permissions",
        INVALID_LANGUAGE_CODE: "Invalid language code",
        INVALID_EMAIL_FORMA: "Invalid email format",
        EMPTY_PASSWORD_NOT_ALLOWED: "Empty password not allowed",
        EMPTY_USERNAME_NOT_ALLOWED: "Empty username not allowed",
        EMPTY_FIRSTNAME_NOT_ALLOWED: "Empty firstname not allowed",
        EMPTY_LASTNAME_NOT_ALLOWED: "Empty lastname not allowed",
        INVALID_USER_SELECTED: "Invalid user selected",
        ACCOUNT_DEACTIVATED:
          "Your account has been deactivated, contact the admin",
        INVALID_REPORT_SELECTED: "Invalid report selected",
      },
      apiCategory: {
        CHECKOUT: "Checkout",
        COOLING: "Cooling",
        DRINKS: "Drinks",
        DRY_GOODS_ASSORTMENT: "Dry Goods Assortment",
        FRUIT_VEGETABLE: "Fruit / Vegetable",
        HIGH_RACK: "High Rack",
        OTHERS: "Others",
        STANDEE: "Standee",
        WAREHOUSE: "Warehouse",
      },
    },
  };
};
